export const codePage = {
  VALIDATE_DOCUMENT: 1,
  ASSIGN_TICKET: 2,
};

export const pagesTicket = [
  {
    step: codePage.VALIDATE_DOCUMENT,
    name: 'ValidateDocument',
  },
  {
    step: codePage.ASSIGN_TICKET,
    name: 'AssignTicket',
  },
];
